import { ICustomer } from "./AllTypes";

export class CreateOrderInsertObject {
  customer: ICustomer = {} as any;
}

export class BaseInsertObject<T> {
  constructor(obj?: Partial<T>) {
    if (obj) {
      for (let key in obj) {
        // @ts-ignore
        this[key] = obj[key];
      }
    }
  }
}

export class SetNameEmailInsertObject {
  AOSAI: string = ""; // Account Opening Session Auth Info
  AORID?: number = 0;
  AORUID?: string = "";
  AOPRID?: number = 0;
  AOPRUID?: string = "";
  CPAN: string = "";
  CDOB: string = "";
  CFN: string = "";
  CMN: string = "";
  CLN: string = "";
  CEID: string = "";
}

export class SetPANDOBInsertObject {
  AOSAI: string = "";
  CPAN: string = "";
  CDOB: string = "";
  CGMF: "M" | "F" = "M";
  BPC?: string;
  DAMCSC?: string; //DematAMCSchemeCode
  SIDISB?: number; //ShouldIssueDISBooklet
}

export class UpdateAORWithPMLAQuestionAnswersInsertObject {
  AOSAI: string = "";
  CFOHN: string = ""; // Client Father Or Husband Name
  CMN: string = ""; // Client Mother Name
  ISNI: number = 0; // Nationality Type Indian Or Other (Inform of checkbox)
  AOSGIC: number = 0; // Gender
  AOSMSIC: number = 0; // Marital Status
  AOSOIC: number = 0; // Occupation Type
  AOSISIC: number = 0; // Income Slab
  AOSPEPSIC: number = 0; // PEP Status
  AOSTEIC: number = 0; // Trading Experience
  DFDLRICCM: number = 0; // eFamilyDeclarationLegatRelationInternalCodeOfMobile
  DFDLRICCE: number = 0; // eFamilyDeclarationLegatRelationInternalCodeOfEmail
}

export class GetAccountOpeningDocumentSearchOptions {
  AOSAI: string = "";
  AODID: number = 0; //(Optional)
  AODUID: string = ""; //(Optional)
  AOPRDID: number = 0; //(Optional)
  AOPRDUID: string = ""; //(Optional)
}

export class UploadAndRegisterAccountOpeningDocumentInsertObject {
  AOSAI: string = "";
  AODTIC?: number; //Mandatory Internal Code
  AODOFN?: string = ""; //Mandatory File Name
  AODB64D?: string = ""; //Mandatory Base64
  AODP?: string = ""; // --> Account Opening Document Password

  AOPRXDID?: number = 0; //Optional
  AOPRXDUID?: string = ""; //Optional

  LGLI?: string;
  LGLat?: number;
  LGLog?: number;
}

export class CreateUpdateNomineeEntryInsertObject {
  AORXNID?: number;
  AORXNUID?: string;

  AOSAI?: string;
  NNT?: string; // NomineeNameTitle
  NFN?: string; // NomineeFirstName
  NMN?: string; // NomineeMiddleName
  NLN?: string; // NomineeLastName
  NDOB?: string; // NomineeDOB
  NSP?: string; // Nominee Share Percentage
  NIPTIC?: string; // NomineeIDProofType
  NIPRN?: string; // NomineeIDProofReferenceNumber
  AOSNR?: string; // NomineeRelation
  NAL1?: string; // NomineeAddressLine1
  NAL2?: string; // NomineeAddressLine2
  NAL3?: string; // NomineeAddressLin3
  NAC?: string; // NomineeAddressCity
  NAD?: string; // NomineeAddressDistrict
  NAP?: string; // NomineeAddressPincode
  NASN?: string; // NomineeAddressStateName
  NACN?: string; // NomineeAddressCountryName

  // Gurdian Info - (If Minor Decide From DOB No Seprate Input)
  GASAN?: string; // GuardianAddressSameAsNominee
  GNT?: string; // GuardianNameTitle
  GFN?: string; // GuardianFirstName
  GMN?: string; // GuardianMiddleName
  GLN?: string; // GuardianLastName
  AOSGRIC?: string; // GuardianRelation
  GDOB?: string; // GuardianDOB
  GIPTIC?: string; // GuardianIDProofType
  GIPRN?: string; // GuardianIDProofReferenceNumber

  // Gudian Address(Conditional GASAN= false)
  GAL1?: string; // GuardianAddressLine1
  GAL2?: string; // GuardianAddressLine2
  GAL3?: string; // GuardianAddressLine3
  GAC?: string; //GuardianAddressCity
  GAD?: string; // GuardianAddressDistrict
  GAP?: string; // GuardianAddressPincode
  GASN?: string; // GuardianAddressStateName
  GACN?: string; // GuardianAddressCountryName
}

export class PrepareESignRequestInsertObject {
  AOSAI: string = "";
  MICDBIC: number = 0; // eMockupIsCustomDerivedBoolean
  MSPNAPA: string = ""; // MockupSignedPersonNameAsPerAadhaar
  MSPAS: string = ""; // MockupSignedPersonAadhaarSuffix
  MSPG: string = ""; // MockupSignedPersonGender
  MSPBY: string = ""; // MockupSignedPersonBirthYear
  MSPP: string = ""; // MockupSignedPerso
}

export class ImpersonateLoginInsertObject {
  AORID: number = 0; //AccountOpeningRequestID
  AORUID: string = ""; //AccountOpeningRequestUID
  AIT: string = ""; //ApplicantImpersonationToken
  TTIC: string = ""; //TokenTypeInternalCode
}
